import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import {Card, CardContent} from "@material-ui/core";
import APPCONFIG from "../../constants/Config";
import {Elements} from "components";

export default class WorkOrderServices extends Framework.Components.Collection {
	constructor(props) {
		super(props, new API.BuildClass(Types.Services._name, API.RequestType.READ_ALL));
		this.state.limit = 10;
		this.limit = 10;
		this.state.services = [];
		this.state.services_error = "";
		this.afterSubmit = this.afterSubmit.bind(this);
	}

	addService = (e) => {
		const pkey = parseInt(e.currentTarget.id, 10);
		const {data, services} = this.state;
		const existingOnContract = (this.props.existingServiceIds || []).some(
			(id) => String(id) === String(pkey)
		);
		if (existingOnContract) {
			this.setState({
				services_error: "This service is already on the work order. Edit the line to change quantity.",
			});
			return;
		}
		if (services.find((entry) => entry.pkey === pkey)) {
			this.setState({services_error: "Service already in list."});
			return;
		}
		const service = data.find((entry) => entry.pkey === pkey);
		if (service) {
			this.setState({
				services: [...services, {...service, quantity: 1}],
				services_error: "",
			});
		}
	};

	removeService = (e) => {
		const pkey = parseInt(e.currentTarget.id, 10);
		this.setState({
			services: this.state.services.filter((entry) => entry.pkey !== pkey),
			services_error: "",
		});
	};

	async afterSubmit() {
		if (typeof this.props.afterSave === "function") {
			this.props.afterSave(this.state.services);
		}
	}

	table = () => {
		const {data, loading, limit, services, services_error} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: (props) => (
					<Button id={props.original.pkey} className="primary-button" style={{ marginTop: '6px' }} size="sm" block onClick={this.addService}>
						<i className="fa fa-plus" />
					</Button>
				),
			},
			{Header: "Name", accessor: "name", className: 'center-column',},
			{
				Header: "Price",
				id: "price",
				className: 'center-column',
				accessor: (r) => `$${parseFloat(r.price || 0).toFixed(2)}`,
			},
			{
				Header: "Taxable",
				id: "taxable",
				className: 'center-column',
				accessor: (r) => (r.taxable ? "Yes" : "No"),
			},
		];

		return (
			<div className="row">
				<div className="col-lg-8">
					<div className="table-bar">
						<div className="d-flex">{this.renderSearch("Services")}</div>
					</div>
					<ReactTable
						columns={columns}
						manual
						data={data}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultPageSize={limit}
						pageSize={10}
						className="-striped -highlight"
					/>
				</div>
				<div className="col-lg-4">
					<h4 className="section-title">Selected Services</h4>
					{services_error ? (
						<div style={{padding: "0 4px 4px", fontStyle: "italic", fontSize: 12, color: "#ef534f", textAlign: "center"}}>
							{services_error}
						</div>
					) : null}
					{services.map((service) => (
						<Elements.ItemLookup
							key={service.pkey}
							product={service}
							remove={this.removeService}
						/>
					))}
				</div>
				{APPCONFIG.settings.isDev() ? null : <Framework.Elements.LoadingSpinner isLoading={loading} />}
			</div>
		);
	};

	render() {
		if (this.props.hasModal) {
			return this.table();
		}
		return (
			<Card>
				<CardContent>{this.table()}</CardContent>
			</Card>
		);
	}
}
